import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { motion } from "framer-motion";

export default function Solutions() {
    const [industries, setIndustries] = useState([]);
    useEffect(() => { api.get("/industries").then((r) => setIndustries(r.data.industries)); }, []);
    return (
        <main data-testid="solutions-page" className="pt-[72px] bg-white">
            <section className="bg-[#0B1930] text-white pt-24 pb-24 relative overflow-hidden grain">
                <div className="hero-glow top-[-20%] right-[10%]" style={{ background: "#E8B923" }} />
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
                    <div className="eyebrow">Solutions</div>
                    <h1 className="headline text-5xl md:text-6xl lg:text-7xl mt-6 max-w-4xl">
                        Enterprise software <br /> for <em className="not-italic text-[#E8B923]">every</em> sector.
                    </h1>
                </div>
            </section>
            <section className="py-20 max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {industries.map((ind, i) => (
                    <motion.div key={ind.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                        <Link to={`/solutions/${ind.slug}`} data-testid={`solution-card-${ind.slug}`} className="block bg-[#F7F9FC] border border-slate-200 rounded-2xl p-8 hover:border-navy transition group h-full">
                            <div className="flex items-center justify-between mb-6">
                                <span className="eyebrow eyebrow--slate">{ind.slug.toUpperCase()}</span>
                                <ArrowUpRight className="w-4 h-4 text-slate-400 group-hover:text-[#E8B923] transition" />
                            </div>
                            <h3 className="font-serif text-2xl text-navy">{ind.name}</h3>
                            <p className="text-slate-600 text-sm mt-3 leading-relaxed">{ind.summary}</p>
                        </Link>
                    </motion.div>
                ))}
            </section>
        </main>
    );
}
